








import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import SurgerySolicitationReadOnlyPageComponent from '@/components/Backoffice/surgery-solicitation-readonly-page.vue'
import router from '@/router/_'

@Component({ components: { SurgerySolicitationReadOnlyPageComponent } })
export default class BackofficeSurgerySolicitationDetailsView extends Vue {
  surgerySolicitationLoadedSuccesfully: boolean = false

  async created() {
    EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

    await this.loadingSurgerySolicitationDetails()

    EventBus.$emit('clearLoadingRequest')
  }

  async loadingSurgerySolicitationDetails() {
    const { solicitacaoId: surgerySolicitationId } = this.$route.params
    this.surgerySolicitationLoadedSuccesfully = false

    this.getBackofficeGlobalStore.setBackofficeArea(this.backofficeArea)

    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)
    if (!response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível carregar as informações da cirurgia', icon: 'warning', color: '#C62828' })
      return
    }

    const { solicitacao } = this.getBackofficeGlobalStore

    if (!solicitacao.acoes || !solicitacao.acoes.visualizar) {
      this.redirectToDefaultPage()
      return
    }

    const { hospitalId } = solicitacao

    await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)

    this.surgerySolicitationLoadedSuccesfully = true
  }

  get backofficeArea() {
    return this.getBackofficeGlobalStore.backofficeArea || this.backofficeUserDefaultArea
  }

  get backofficeUserDefaultArea() {
    if (this.getBackofficeGlobalStore.backofficeArea) {
      return this.getBackofficeGlobalStore.backofficeArea
    }
    // $user pode ainda não estar carregado quando esta tela abre numa aba nova
    // (window.open recarrega o app do zero, diferente de navegação dentro da SPA).
    const defaultPage = this.$user && this.$user.profile && this.$user.profile.defaultPage

    if (defaultPage && defaultPage.keyAuthorized.includes('backoffice-')) {
      return defaultPage.keyAuthorized.includes('backoffice-pre-anestesico')
        ? 'preanestesia'
        : defaultPage.keyAuthorized.replace('backoffice-', '')
    }

    return 'agendamento'
  }

  redirectToDefaultPage() {
    if (window.opener) {
      window.close()
      return
    }

    router.back()
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }
}
